export const getServiceRequestDetail = (state) => state.serviceRequestDetail;